import { EnvironmentConfig, parseBooleanEnv, parseStringArrayEnv } from './environment.types';

export const environment: EnvironmentConfig = {
  production: false,
  hasSupportProvider: parseBooleanEnv('HASSUPPORTPROVIDER'),
  hasLLMService: parseBooleanEnv('HASLLMSERVICE'),
  hasPaymentsEnabled: parseBooleanEnv('HASPAYMENTSENABLED'),
  hasEmailProvider: parseBooleanEnv('HASEMAILPROVIDER'),
  authProviderNames: parseStringArrayEnv('AUTHPROVIDERNAMES'),
  posthogApiKey: null,
  baseUrl: 'https://dev-api.duplicati.com',
  machineServerUrl: 'wss://dev-gateway.api.duplicati.com/portal',
  clientAppUrl: 'https://client.dev-app.duplicati.com',
  storageGatewayUrl: 'https://dev-storage.duplicati.com',
  activityMonitorUrl: 'https://dev-activitymonitor.duplicati.com',
};
